<template>
  <div
    v-if="message"
    class="share-success-bar"
  >
    <i class="share-success-bar__icon">
      <SuccessIcon />
    </i>
    <span class="share-success-bar__message">{{ message }}</span>
    <span
      class="share-success-bar__action"
      @click="gotoPanView"
      >{{ t('goto-view') }}</span
    >
  </div>
</template>

<script lang="ts" setup>
import { ref, useI18n, watch } from '#imports'
import SuccessIcon from '@/components/icons/SuccessIcon.vue'
import { useShare } from '@/store/share'
import useShareFiles from '~/composables/useShareFiles'

const { t } = useI18n()
const message = ref('')
const shareStore = useShare()

const files = useShareFiles()

const gotoPanView = () => {
  shareStore.gotoHighlightFile()
}

const update = () => {
  // 过滤出属于当前目录的数据
  const savedIds = shareStore.restoreCache.savedIds || []
  const fileIds = files.value.map(item => item.id)
  // 当前目录已保存的文件 id
  const list = savedIds.filter(id => fileIds.includes(id))
  const savedAll = list.length === files.value.length

  if (shareStore.selectedIds.length) {
    const selectAndSaveIds = shareStore.selectedIds.filter(id => savedIds.includes(id))
    message.value = selectAndSaveIds.length ? t('partial-saved-text', [selectAndSaveIds.length]) : ''
  } else if (list && list.length) {
    message.value = savedAll ? t('all-saved-text') : t('partial-saved-text', [list.length])
  } else {
    message.value = ''
  }
}

watch([() => shareStore.restoreCache.savedIds, () => shareStore.selectedIds, files], update, { immediate: true })
</script>

<style lang="less" scoped>
.share-success-bar {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;

  &__icon {
    display: flex;
    width: 24px;
    height: 24px;
    margin-right: 12px;
  }

  &__message {
    color: #fff;
  }

  &__action {
    color: #6794ff;
    cursor: pointer;
    margin-left: 12px;

    &:hover {
      text-decoration: underline;
    }
  }

  &__divider {
    width: 1px;
    height: 18px;
    background-color: #98a2ad66;
    margin: 0 24px;
  }

  &__close {
    display: flex;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}
</style>
